/**
 * Maximum number of pages to index for SEO
 * Business rule: Don't link past this page to avoid indexing too many pages or wasting crawl budget
 */
export const MAX_INDEXABLE_PAGES = 5;

/**
 * Number of reviews per page on dedicated review pages (e.g., /p/reviews/..., /store/.../reviews/).
 * Distinct from the 10-per-page count embedded on non-review pages (e.g., /p/..., /store/...).
 * Business rule: Used to calculate total review page count for SEO href generation.
 */
export const DEDICATED_REVIEW_PAGE_SIZE = 30;

/**
 * Maximum number of results returned by the reviews API.
 * Used to calculate the maximum page count for dedicated review pages.
 */
export const MAX_REVIEW_API_RESULTS = 500;

/**
 * Default number of products per page for BRO's pagination
 */
export const BROS_PAGE_SIZE = 32;